module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "headLine"
    }
  }, [_c('div', {
    staticClass: "hlImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headLineImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "latest-icon"
  }, [_vm._v(_vm._s(_vm.latestTag))]), _vm._v(" "), _c('div', {
    staticClass: "latest-text"
  }, [_c('div', [_vm._v(_vm._s(_vm.latestText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-b2a8a82c!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/headLine.vue
// module id = 54
// module chunks = 1